// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
export const CatalogueVideoFragmentDoc = gql`
    fragment catalogueVideo on CatalogueVideo {
  __typename
  uri
  type
}
    `;